import useOrganizationData from "hooks/organizaton/useOrganization";

const { Text } = require("@chakra-ui/react");

const TermsAndConditions = ({isProforma, headingClassName = ''}) => {
  const { organizationData } = useOrganizationData();
  const tq = (isProforma ? organizationData?.pfTc : organizationData?.stc) || "";

  const termsArray =
    tq.split('\n').filter((term) => term.trim() !== "") || [];
  return (
    <>
      {termsArray.length > 0 && (
        <>
          <Text className={headingClassName}>Terms & Conditions</Text>
          {termsArray.map((term, index) => {
            const trimmedTerm = term.trim();
            return trimmedTerm ? (
              <Text className="terms-text" key={index}>
                {trimmedTerm}
              </Text>
            ) : null;
          })}
        </>
      )}
    </>
  );
};

export default TermsAndConditions;
